import "./style.scss";

const PageTitle = ({ content }: { content: string }) => {
  return <div className={"page-title"}>{content}</div>;
};

export default PageTitle;
